import {
  Datagrid,
  FunctionField,
  List,
  SimpleList,
  TextField,
  TopToolbar,
  useRedirect,
  type RaRecord,
  Button,
} from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";
import { formatListDate, formatWeekdayShort } from "@/utils/date-format";
import { useRouteId } from "@/utils/route-utility";
import type { HouseVisitSlotRecord } from "../types";
import { HouseVisitSlotsViewToggle } from "./HouseVisitSlotsViewToggle";

const stopCount = (r: HouseVisitSlotRecord) =>
  r.stopCount ?? r._count?.stops ?? r.stops?.length ?? 0;

const ListActions = () => (
  <TopToolbar>
    <HouseVisitSlotsViewToggle />
  </TopToolbar>
);

export const HouseVisitSlotList = () => {
  const eventId = useRouteId();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  const redirect = useRedirect();

  if (!eventId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">Open a house visit event to plan slots.</Typography>
      </Box>
    );
  }

  return (
    <List
      perPage={50}
      sort={{ field: "date", order: "ASC" }}
      filter={{ eventId }}
      title={false}
      actions={<ListActions />}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(r) =>
            `${formatWeekdayShort(String(r.date), { utc: true })} · ${formatListDate(String(r.date), { utc: true })}`
          }
          secondaryText={(r) => {
            const slot = r as HouseVisitSlotRecord;
            const label = slot.label ? `${slot.label} · ` : "";
            return `${label}${stopCount(slot)}/${slot.capacity ?? "?"} stops`;
          }}
          linkType="show"
        />
      ) : (
        <Datagrid rowClick="show" bulkActionButtons={false}>
          <FunctionField
            label="Date"
            render={(r: RaRecord) => formatListDate(String(r.date), { utc: true })}
          />
          <FunctionField
            label="Weekday"
            render={(r: RaRecord) => formatWeekdayShort(String(r.date), { utc: true })}
          />
          <TextField source="label" emptyText="—" />
          <FunctionField
            label="Stops"
            render={(r: RaRecord) => {
              const slot = r as HouseVisitSlotRecord;
              return `${stopCount(slot)} / ${slot.capacity ?? "—"}`;
            }}
          />
          <FunctionField
            label=""
            render={(record: RaRecord) => (
              <Button
                label="Open planner"
                onClick={(e) => {
                  e.stopPropagation();
                  redirect("show", "houseVisitSlots", record.id);
                }}
              />
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};
